import styled from 'styled-components';

// we need this to prevent jumping of changing tabs
export default styled.div`
  /* min-height: 100vh; */
`;
